import React, { Component } from 'react'
import pt from 'prop-types'
import { connect } from 'react-redux'

import { openMod } from '../../modules/mods'

import './style.scss'

import AddPickTop from '../icon/AddPickTop'
import SaveButton from '../icon/SaveButton'

class FeedContextMenu extends Component {
  render() {
    const { openMod } = this.props

    return (
      <div className={`feed-context-menu`}>
        <ul className="feed-context-menu__list">
          <li
            className="feed-context-menu__list-item"
            onClick={() => {
              openMod({ type: 'addPick', args: { transparentBg: true }, params: { fromMyPicks: true } })
            }}
          >
            <div className="feed-context-menu__list-icon">
              <AddPickTop width="20px" height="20px" />
            </div>
            Pick from a Link
          </li>
          <li
            className="feed-context-menu__list-item"
            onClick={() => openMod({ type: 'addPick', args: { transparentBg: true }, params: { fromMySaved: true } })}
          >
            <div className="feed-context-menu__list-icon">
              <SaveButton />
            </div>
            Save from a Link
          </li>
        </ul>
      </div>
    )
  }
}

FeedContextMenu.propTypes = {
  openMod: pt.func
}

const mapDispatchToProps = {
  openMod
}

const mapStateToProps = state => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedContextMenu)
